<template>
  <v-dialog v-model="toggle" max-width="600px">
    <v-card
    >
      <v-container
        fill-height
        class="banner"
        :style="{ background: `url(${job.backgroundImage}) no-repeat center` }"
      >
        <v-row>
          <v-col cols="12" sm="12" md="8" lg="8" xl="8">
            <div class="display-2 primary--text font-weight-bold pl-2">{{ job.title }}</div>
          </v-col>
        </v-row>
      </v-container>
      <v-card-text class="px-5 py-3">
        <div class="py-1">
          <!-- <h4 class="primary--text">Education</h4> -->
          <p class="pre-wrap">{{ job.description }}</p>
        </div>

        <hr>

        <div class="py-2">
          <v-row>
            <v-col cols="6">
              <h4 class="primary--text pb-3">Apply now!</h4>
              <!-- <router-link to="/"> -->
                <a href="mailto:jobs@medgatephilippines.com">
                  <v-icon left color="primary">mdi-email-outline</v-icon>
                  <span class="font-weight-bold black--text">jobs@medgatephilippines.com</span>
                </a>
              <!-- </router-link> -->
            </v-col>

            <v-col cols="6" align-self="end">
              <div class="justify-end d-flex">
                <div>
                  <v-img src="@/assets/images/medgate_logo_blue.png" width="150"></v-img>
                </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "JobDialog",

    props: {
      value: { type: Boolean, default: false },
      job: {}
    },

    data() {
      return {
        toggle: this.value,
      }
    },

    watch: {
      value(val) {
        this.toggle = val;
      },
      toggle(val) {
        this.$emit('input', val);
      }
    }
  }
</script>

<style lang="scss" scoped>
.banner {
  height: 300px;
  background-size: cover;
}

.v-card {
  overflow-x: hidden;
}
</style>